module.exports = __webpack_public_path__ + "img/huawei-logo-white.18da4330.png";